import React from "react";
import clsx from "clsx";
import dropzone from "dropzone";
import ModalButtons from "../ModalButtons/ModalButtons";
import I18n from "i18n-js";

class ImageBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.dropzoneInputRef = React.createRef();

    this.state = {
      activeTab: "general",
      errors: {},
      file_name: null,
      uploading: false,
      progress: 0,
      image_groups: this.props.image
        ? [{ images: [this.props.image] }]
        : [{ images: [] }],
      mode:
        typeof this.props.mode !== "undefined" ? this.props.mode : "multiple",
      remove:
        typeof this.props.remove !== "undefined" ? this.props.remove : true,
      tabs: typeof this.props.tabs !== "undefined" ? this.props.tabs : false,
    };
    this.onClickOK = this.onClickOK.bind(this);
  }

  componentDidMount() {
    this.initDropzone();
  }

  componentDidUpdate(prevProps) {
    this.initDropzone();
  }

  initDropzone() {
    if (!this.dropzoneInputRef.current) {
      return;
    }

    var self = this;
    var $dropzoneInput = $(this.dropzoneInputRef.current);

    if ($dropzoneInput.hasClass("dz-clickable")) {
      return;
    }

    $dropzoneInput.dropzone({
      autoProcessQueue: true,
      url: $dropzoneInput.attr("data-url"),
      uploadMultiple: false,
      paramName: `${this.props.upload_type}[upload]`,
      addedfile: function (file) {
        self.setState({ uploading: true, progress: 0, file_name: file.name });
      },
      uploadprogress: function (file, progress) {
        self.setState({ progress: progress });
      },
      success: function (file, response) {
        var response_image = response.json
        if (self.state.image_groups && self.state.image_groups.length) {
          var imageGroup = self.state.image_groups[0];
          if (!imageGroup.images || !imageGroup.images.length) {
            imageGroup.images = [];
          }

          imageGroup.images.unshift(response_image);
          self.setState(
            { uploading: false, progress: 100, file_name: null, errors: {} },
            () => {
              self.setState({ image_groups: [imageGroup] });
            }
          );
        }
        // self.addDimensions(file, response.json);
      },
      error: function (file, response) {
        if (Object.keys(response).length) {
          self.setState({
            errors: response,
          });
        }
        self.setState({ uploading: false, progress: 100, file_name: null });
      },
    });

    /* dropzone visual cues when dragging */
    $dropzoneInput
      .on("dragover", function (e) {
        e.preventDefault();
        $(this).addClass("dragover");
      })
      .on("dragleave drop", function () {
        $(this).removeClass("dragover");
      });

    /* prevent window from loading dropped file that misses the dropzone */
    window.addEventListener(
      "dragover",
      function (e) {
        e.preventDefault();
      },
      false
    );

    window.addEventListener(
      "drop",
      function (e) {
        e.preventDefault();
      },
      false
    );
  }

  findImage(id) {
    if (this.state.image_groups && this.state.image_groups.length) {
      var imageGroup = this.state.image_groups[0];

      for (var i = 0, ilen = imageGroup.images.length; i < ilen; i++) {
        if (imageGroup.images[i].id == id) {
          return imageGroup.images[i];
        }
      }
    }
  }

  render() {
    var imageGroup =
      this.state.image_groups && this.state.image_groups.length
        ? this.state.image_groups[0]
        : { images: [] };

    var buttons = [
      {
        name: I18n.t("ok"),
        onClick: this.onClickOK,
      },
    ];

    if (this.state.tabs) {
      var generalTabClasses = clsx({
        active: this.state.activeTab == "general",
        "tab-pane": true,
      });

      return (
        <div className="image-group-builder">
          <div className="panel panel-form" style={{margin: 0}}>
            <ul className="nav nav-tabs">
              <li
                role="presentation"
                className={this.state.activeTab === "general" ? "active" : null}
              >
                <a href="#" onClick={this.setActiveTab.bind(null, "general")}>
                  {I18n.t("general")}
                </a>
              </li>
              <li
                role="presentation"
                className={
                  this.state.activeTab === "room_types" ? "active" : null
                }
              >
                <a
                  href="#"
                  onClick={this.setActiveTab.bind(null, "room_types")}
                >
                  {I18n.t("room_types")}
                </a>
              </li>
            </ul>
            <div className="tab-content">
              <div className={generalTabClasses}>
                {this.renderDropzone()}
                {this.renderImages(imageGroup)}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="image-group-builder">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          {this.renderErrors()}
          <div className="panel panel-default" style={{ margin: 0 }}>
            <div className="panel-heading">
              <h3 className="panel-title pull-left">
                {I18n.t(
                  this.props.dropzone_title
                    ? this.props.dropzone_title
                    : "images"
                )}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t(this.props.helperText)}
                ></span>
              </h3>
              <div className="clearfix"></div>
            </div>
            <div className="panel-body">
              {this.props.read_only ? null : this.renderDropzone()}
              {this.renderImages(imageGroup)}
            </div>
          </div>
        </div>
      );
    }
  }

  renderDropzone() {
    return (
      <div
        className="dropzone-container"
        data-dropzone-preview="image"
        key="dropzone"
      >
        <div
          className="dropzone-image-spinner"
          style={{ display: this.state.uploading ? "block" : "none" }}
        >
          <div
            className="progress"
            style={{ width: this.state.progress + "%" }}
          ></div>
          <i className="fa fa-3x fa-spinner fa-spin spinner"></i>
          {this.renderName()}
        </div>

        <div
          ref={this.dropzoneInputRef}
          className="dropzone-input upload btn btn-lg btn-default btn-block"
          data-url={this.props.path}
          data-name={this.props.upload_type}
          data-file-name="upload_file_name"
        >
          {I18n.t(this.props.click_text)}
        </div>
      </div>
    );
  }

  renderName() {
    if (this.state.file_name && this.state.progress == 100) {
      return (
        <div className="name">
          {I18n.t("processing_and_saving")} {this.state.file_name}.{" "}
          {I18n.t("please_wait_ellipsis")}
        </div>
      );
    } else if (this.state.file_name && this.state.progress != 100) {
      return (
        <div className="name">
          {I18n.t("uploading")} {this.state.file_name} {I18n.t("ellipsis")}
        </div>
      );
    }
  }

  renderImages(imageGroup) {
    var self = this;
    var idx = -1;
    var images =
      imageGroup.images && imageGroup.images.length
        ? imageGroup.images
            .sort(function (a, b) {
              if (a.position < b.position) return -1;
              if (a.position > b.position) return 1;
              return 0;
            })
            .map(function (image) {
              idx = idx + 1;
              return self.renderImage(image, idx);
            })
        : null;

    if (
      this.props.read_only === true &&
      (images == null || images.length == 0)
    ) {
      return (
        <div className="no-records">
          <span className="none">{I18n.t("none")}</span>
        </div>
      );
    } else {
      return (
        <div style={{ display: images && images.length ? "block" : "none" }}>
          {images}
        </div>
      );
    }
  }

  renderImage(image, idx) {
    return (
      <div
        className="sortable-image image-row row"
        data-id={image.id}
        key={image.id}
      >
        <div className="label col-sm-2">
          <a
            href={image.original_url}
            className="open-new-window"
            target="_blank"
          >
            <span className="ss-scaleup"></span>{" "}
            <img src={image.thumb_medium_url} />
          </a>
        </div>
        <div className="col-sm-2">{image.upload_file_name}</div>
        <div className="col-sm-2">{image.upload_content_type}</div>
        <input
          type="hidden"
          name="image_group_images_image_id[]"
          value={image.id}
        />
        <input
          type="hidden"
          name={"image_group_images_" + image.id + "_position"}
          className="position"
          value={idx}
        />
      </div>
    );
  }

  onClickOK() {
    if (this.state.image_groups[0].images.length > 0) {
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t("images_uploaded_successfully"));
      }
    }

    if (parent && parent.hide_modal) {
      parent.hide_modal();
    }
  }

  renderErrors() {
    var errors = this.state.errors;

    if (errors && errors.error) {
      return (
        <div className="alert alert-danger">
          <div>{errors.error}</div>
        </div>
      );
    }
  }

  // addDimensions = (dropZoneFile, dropZoneResponse) => {
  //   $.ajax({
  //     type: "POST",
  //     url: this.props.assign_dimensions_path,
  //     data: {
  //       image: {
  //         id: dropZoneResponse.id,
  //         width: dropZoneFile.width,
  //         height: dropZoneFile.height,
  //       },
  //       id: dropZoneResponse.id,
  //     },
  //   }).done((response) => {
  //     if (response.type != "error") {
  //       if (this.state.image_groups && this.state.image_groups.length) {
  //         var imageGroup = this.state.image_groups[0];
  //         if (!imageGroup.images || !imageGroup.images.length) {
  //           imageGroup.images = [];
  //         }

  //         imageGroup.images.unshift(response.image);
  //         this.setState(
  //           { uploading: false, progress: 100, file_name: null, errors: {} },
  //           () => {
  //             this.setState({ image_groups: [imageGroup] });
  //           }
  //         );
  //       }
  //     }
  //   });
  // };
}

export default ImageBuilder;
